import {
  CollectionOptions,
  ContentInstructions,
  CoreContents,
  ExportOptions,
  FromSettingsInstruction,
} from '../../../types';
import { DataOptionsFactory } from '../data';
import { ContentFactory } from './base';

export type TimeSeriesOptions = {
  data?: DataOptionsFactory;
  xColumn: string | FromSettingsInstruction;
  yColumn: string | FromSettingsInstruction;
  displayAs?: string | FromSettingsInstruction;
  exportOptions?: ExportOptions;
  collectionOptions?: CollectionOptions;
};

export class TimeSeriesFactory extends ContentFactory {
  constructor(options: TimeSeriesOptions) {
    const { xColumn, yColumn, displayAs, data, exportOptions, collectionOptions } = options;

    const instructions: ContentInstructions = {
      xColumn:
        typeof xColumn === 'string'
          ? {
              type: 'StringInstruction',
              instruction: xColumn,
            }
          : xColumn,
      yColumn:
        typeof yColumn === 'string'
          ? {
              type: 'StringInstruction',
              instruction: yColumn,
            }
          : yColumn,
      ...(exportOptions && {
        export: {
          type: 'ObjectInstruction',
          instruction: exportOptions,
        },
      }),
      ...(collectionOptions && {
        collection: {
          type: 'ObjectInstruction',
          instruction: collectionOptions,
        },
      }),
    };

    if (displayAs) {
      instructions.displayAs =
        typeof displayAs === 'string'
          ? {
              type: 'StringInstruction',
              instruction: displayAs,
            }
          : displayAs;
    }

    super(CoreContents.timeSeries, {
      data: data || DataOptionsFactory.asReceiver(),
      instructions,
    });
  }
}
